import store from './store/index';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import MainRoutes from './MainRoutes';
import 'webrtc-adapter';

import 'erxes-icon/css/erxes.min.css';
import 'react-datetime/css/react-datetime.css';
import 'react-toggle/style.css';

import 'modules/theme/theme1/common/styles/bootstrap-grid.css';
import 'modules/theme/theme1/common/styles/bootstrap-utilities.css';
import 'modules/theme/theme1/common/styles/common.css';
import 'modules/theme/theme1/common/styles/global-styles.js';

const target = document.querySelector('#root');

render(
  <Provider store={store}>
    <MainRoutes />
  </Provider>,
  target
);



// WEBPACK FOOTER //
// src/index.js